module.exports = __webpack_public_path__ + "static/tax-documents-hero-desktop.16433cee.webp";